<template>
	<div class="collection">
		<div class="icon">
			<span class="fas fa-folder"></span>
		</div>
		<div class="collection_name">
			{{ name }}
		</div>
		<div class="last_update">
			<span class="content_title">Atualizado em: </span>
			<span class="content">{{ `${lastUpdate.getDate().toString().padStart(2, '0')}/${(lastUpdate.getMonth() + 1).toString().padStart(2, '0')}/${lastUpdate.getFullYear()}` }}</span>
		</div>
		<div class="actions">
			<button>
				<span class="fas fa-eye"></span>
				Visualizar
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CollectionItem',
	props: {
		name: { type: String, default: '' },
		lastUpdate: { type: Date, default: '' }
	}
}
</script>

<style lang="scss" scoped>
	.collection {
		display: grid;
		align-items: center;
		align-content: center;
		grid-template-columns: .5fr 10fr 1fr 1.5fr;
		padding: 10px 20px;
		border: 2px solid #21344D;
		border-radius: 10px;
		background-color: #061529;
		color: #59708F;
		font-family: 'Roboto Condensed', 'Roboto', sans-serif;
		margin-bottom: 10px;

		body.light & {
			color: #FFF;
		}

		@media all and (max-width: 1600px) {
			grid-template-columns: .5fr 5fr 2fr 2fr;

			@media all and (max-width: 800px) {
				& {
					display: block;

					& .icon {
						display: inline-block;
						margin-right: 10px;
					}

					& .collection_name {
						display: inline-block;
					}
				}
			}
		}

		.last_update {
			align-items: center;

			.content_title {
				display: block;
				color: #99BCE5;
				font-size: 14px;
				text-align: center;

				@media all and (max-width: 800px) {
					display: inline-block;
					color: unset;
					font-size: unset;
					margin-right: 10px;
				}
			}

			.content {
				display: block;
				margin-top: -5px;
				text-align: center;

				@media all and (max-width: 800px) {
					display: inline-block;
				}
			}
		}

		.actions {
			margin-left: auto;

			@media all and (max-width: 800px) {
				margin: 10px auto 0 auto;
				text-align: center;
			}

			button {
				padding: 8px;
				border: none;
				border-radius: 5px;
				font-weight: bold;
				background-color: #E2E41A;
				color: #06162B;
				text-transform: uppercase;
				cursor: pointer;

				&:hover {
					background-color: #FAFF00;
				}
			}
		}
	}
</style>
